// extracted by mini-css-extract-plugin
export default {"table":"FeaturesComponents_table__y6tP8","imageContainer":"FeaturesComponents_imageContainer__2mvIl","light":"FeaturesComponents_light__YUGAW"};